export const OTHER_BOOLEAN_FIELDS = [
  "isProfessionalInvestor",
  "isVulnerableCustomer",
] as const;

export type OtherBooleanField = (typeof OTHER_BOOLEAN_FIELDS)[number];

export function isOtherBooleanField(field: string): field is OtherBooleanField {
  return (OTHER_BOOLEAN_FIELDS as readonly string[]).includes(field);
}

export function normalizeOtherBooleanValue(value: any): boolean | null | undefined {
  if (value === null || value === undefined) return value;
  if (typeof value === "boolean") return value;

  if (typeof value === "number") {
    if (value === 1) return true;
    if (value === 0) return false;
    return null;
  }

  if (typeof value !== "string") return null;

  const normalizedValue = value.trim().toUpperCase();
  if (!normalizedValue) return null;
  if (["YES", "Y", "TRUE", "1"].includes(normalizedValue)) return true;
  if (["NO", "N", "FALSE", "0"].includes(normalizedValue)) return false;

  return null;
}

export function normalizePolicyholderOtherBooleanFields<T extends Record<string, any> | null | undefined>(
  policyholder: T,
): T {
  if (!policyholder || typeof policyholder !== "object") {
    return policyholder;
  }

  const nextPolicyholder: Record<string, any> = { ...policyholder };

  for (const field of OTHER_BOOLEAN_FIELDS) {
    if (field in nextPolicyholder) {
      nextPolicyholder[field] = normalizeOtherBooleanValue(nextPolicyholder[field]);
    }
  }

  if (policyholder.other && typeof policyholder.other === "object") {
    nextPolicyholder.other = { ...policyholder.other };

    for (const field of OTHER_BOOLEAN_FIELDS) {
      if (field in nextPolicyholder.other) {
        nextPolicyholder.other[field] = normalizeOtherBooleanValue(
          nextPolicyholder.other[field],
        );
      }
    }
  }

  return nextPolicyholder as T;
}
